import { getStaffDetails, toast } from "@/common/api";
class Utils {
  // 首页接口调用函数
  getDataIndex(that, params, funcHandel, flag) {
    //参数说明1.that指传入的this对象;2、接口要用的参数；3，funcHandel返回的回调函数,接口链接,4,数据返回的方式标识
    that.centralControl.axios.centralControl(
      funcHandel,
      res => {
        const { code, data, message } = res;
        if (code == 200) {
          if (flag) {
            that[funcHandel] = data;
          } else {
            that[funcHandel](data);
          }
        } else {
          toast(that, message, "error");
        }
      },
      params
    );
  }
  // 循环配置链接，请求首页数据
  // eachIndexattr(that,attr,interfaceAttr) {
  //   for (let items in attr) {
  //     let objs = interfaceAttr.filter(item => {
  //       return item.interfaceName == attr[items];
  //     });
  //     let items = objs[0];
  //     that.centralControl.utils.getDataIndex(
  //       that,
  //       items.params,
  //       items.interfaceName,
  //       items.flag
  //     );
  //   }
  // }
  eachIndexattr(that,attr,interfaceAttr) {
    for (let items in attr) {
      let objs = interfaceAttr.filter(item => {
        return item.interfaceName == attr[items];
      });
      let item = objs[0];
      that.centralControl.utils.getDataIndex(
        that,
        item.params,
        item.interfaceName,
        item.flag
      );
    }
  }
  // 根据后台返回的照片字段判断默认显示头像
  chargeHeaderImg(info, imgUrl) {
    return info[imgUrl]
      ? info[imgUrl]
      : info.sex == "2"
      ? require("../../assets/images/doctor.png")
      : require("../../assets/images/male_img.png");
  }
  // 统一获取岗位和职称的字典项
  gaindictItem(that, type, falg, attrAll, urlHref) {
    let dataAttr = { dictType: type };
    that.centralControl.axios.centralControl(
      urlHref,
      res => {
        const { code, data, message } = res;
        if (code == 200) {
          if (falg) {
            that[attrAll] = data;
            console.log(data);
          } else {
            that[attrAll](data);
          }
        } else {
          that.$message.error(message);
        }
      },
      dataAttr
    );
  }
  // 上传图片到服务器
  uploadImg(file) {
    var obj = { file };
    this.centralControl.axios.centralControl(
      "uploadFile",
      res => {
        const { data, code } = res;
        if (code == "200") {
          return data.fileKey;
        } else {
          toast(this, res.message, "error");
        }
      },
      obj
    );
  }
  // 重新获取用户信息，并且把它存到locastorage中
  replayGetDate(id) {
    // 获取会员信息
    getStaffDetails({
      id
    }).then(res => {
      if (res.code == 200) {
        console.log(res.data);
        localStorage.setItem("detailInfo", JSON.stringify(res.data));
      } else {
        toast(this, res.message, "error");
      }
    });
  }
  //修改title
  updateDocumentTitle(str) {
    document.title = str;
  }
  //传入要获取得对象得属性  和 配置数组
  getConfig(obj, arr) {
    var objCopy = JSON.parse(JSON.stringify(obj));
    for (var a = 0; a < arr.length; a++) {
      objCopy = objCopy[arr[a]];
    }
    return objCopy;
  }

  //传入对象，和对象的key返回指定的value值，只支持一层
  getConfigTitle(obj, str_1, str_2, value) {
    for (let key in obj) {
      if (obj[key][str_1] == value) {
        return obj[key][str_2];
      }
    }
  }
  // 获取东八时区
  obtainEast8Date() {
    var timezone = 8; //目标时区时间，东八区   东时区正数 西市区负数
    var offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
    var nowDate = new Date().getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
    var targetDate = new Date(
      nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000
    );
    return targetDate;
  }
}
let utils = new Utils();
export default utils;

Date.prototype.format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }

  return fmt;
};
